import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Assignment } from "types";

interface PublicAssignmInfoProps {
  linkSlug: string | undefined;
}
type PublicAssignmInfo = {
  therapistId: string;
  therapistName: string;
  therapistEmail: string;
  therapistIcon: string;
  practiceName: string;
  practiceLogo: string;
  groupName: string;
  assignment: Assignment;
  visibleToPatient: boolean;
};

const useFetchPublicAssignment = ({ linkSlug }: PublicAssignmInfoProps) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [publicAssignmInfo, setPublicAssignmInfo] =
    useState<PublicAssignmInfo | null>(null);

  const fetchPublicAssignmInfo = () => {
    setLoading(true);
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_REST_API_URL}/p/assignment/${linkSlug}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(async (res) => {
          if (res.status !== 200) {
            navigate("/not-found");
          }
          return await res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            navigate("/not-found");
          } else {
            setPublicAssignmInfo(resData);
          }
        })
        .finally(() => setLoading(false));
    });
  };

  return { fetchPublicAssignmInfo, publicAssignmInfo, loading };
};

export default useFetchPublicAssignment;
